import { render, staticRenderFns } from "./PainelProece.vue?vue&type=template&id=5b5e16a2"
import script from "./PainelProece.vue?vue&type=script&lang=js"
export * from "./PainelProece.vue?vue&type=script&lang=js"
import style0 from "./PainelProece.vue?vue&type=style&index=0&id=5b5e16a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports